import React from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';

import DownloadIcon from '../../../components/Icons/DownloadIcon';
import useExportWaitlist from '../../../hooks/dashboard/waitlist-submissions/useDownloadDriverTemplate';

const Export = () => {
  const { downloadWaitlist, loading } = useExportWaitlist();

  return (
    <Container onClick={() => downloadWaitlist()}>
      Export {loading ? <LoadingOutlined /> : <DownloadIcon />}
    </Container>
  );
};

export default Export;

const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.blueColor};
  color: ${({ theme }) => theme.palette.blueColor};
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  & > svg {
    color: ${({ theme }) => theme.palette.blueColor};
  }
`;
